"use client";
import a from "./index.es65.js";
import r from "react";
const n = ({
  children: e,
  className: t = "",
  ...l
}) => /* @__PURE__ */ r.createElement(
  "h1",
  {
    ...l,
    className: `${t} bl-size-1 bl-p-b-7`,
    style: { textAlign: "center" }
  },
  e
), m = a(n)`
  text-align: center;
`;
export {
  m as default
};
//# sourceMappingURL=index.es30.js.map
